import React from 'react'
import { useWindowSize } from '../../../modules/staking'
import { MOBILE_SIZE } from '../../../core/constants/common'
import SwapHistoryTable from '../../../components/transactionNew/swap/SwapHistoryTable'
import RSwapHistoryTable from '../../../components/transactionNew/swap/RSwapHistoryTable'

const SwapHistory = () => {

    const { width } = useWindowSize()

    return (
        <>
            {width > MOBILE_SIZE ? <SwapHistoryTable /> : <RSwapHistoryTable />}
        </>
    )
}

export default SwapHistory